export const ContractActionType = {
  RESET_CONTRACT_DATA: "RESET_CONTRACT_DATA",
  SET_CONTRACT_INFO: "SET_CONTRACT_INFO",
  SET_PROGRAM_DURATION: "SET_PROGRAM_DURATION",

  SET_TOTAL_FEES_COLLECTED: "SET_TOTAL_FEES_COLLECTED",

  SET_FEES_DEDUCTED: "SET_FEES_DEDUCTED",
  SET_MAX_DAFI: "SET_MAX_DAFI",
  SET_DIST_POOL_BALANCE: "SET_DIST_POOL_BALANCE",
};
